import { Camera, Send, Wrench } from "lucide-react";

export function AskPage() {
  return (
    <main className="page-canvas">
      <section className="container ask-page">
        <div className="ask-intro">
          <Wrench aria-hidden="true" />
          <h1>Hỏi là có</h1>
          <p>
            Gửi ảnh, mã phụ tùng, dòng xe hoặc mô tả lỗi. Request được đưa vào pipeline
            sourcing để chờ kết nối database và supplier thật.
          </p>
        </div>
        <form className="ask-form" onSubmit={(event) => event.preventDefault()}>
          <label>
            Dòng xe / mã phụ tùng
            <input placeholder="Ví dụ: Klara 60V bộ sạc tự ngắt" />
          </label>
          <label>
            Mô tả nhu cầu
            <textarea placeholder="Mô tả triệu chứng, ảnh tem, kích thước hoặc mã thay thế..." />
          </label>
          <div className="upload-box">
            <Camera aria-hidden="true" />
            <span>Tải ảnh phụ tùng hoặc tem SKU</span>
          </div>
          <button className="btn btn-primary" type="submit">
            <Send aria-hidden="true" />
            <span>Gửi yêu cầu</span>
          </button>
        </form>
      </section>
    </main>
  );
}
